import React, { useCallback, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import referralService from '../services/referralService';
import Swal from 'sweetalert2';
import PageLoader from '../components/common/PageLoader';

function ReferralRedirect() {
    const { token } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    const validateReferral = useCallback(async () => {
        try {
            const response = await api.get(`/ref/${token}`);
            
            // Store referral data in localStorage
            referralService.setReferral(response.data.data);

            // Show success message
            await Swal.fire({
                icon: 'success',
                title: 'Referral Link Valid',
                text: `You've been referred by ${response.data.data.partner_name || 'a partner'}. Your referral code has been saved!`,
                timer: 3000,
                showConfirmButton: false
            });

            // Redirect to register page
            navigate('/register');
        } catch (error) {
            const message = error.response?.data?.message || 'Invalid referral link';
            
            await Swal.fire({
                icon: 'error',
                title: 'Invalid Referral',
                text: message
            });

            // Redirect to register page anyway
            navigate('/register');
        } finally {
            setLoading(false);
        }
    }, [navigate, token]);

    useEffect(() => {
        validateReferral();
    }, [validateReferral]);

    if (loading) {
        return <PageLoader force copy="Validating referral link..." />;
    }

    return null;
}

export default ReferralRedirect;
